export const RequiredErrorMessages = {
    EMOJIS: 'Seleccione una opción',
    LINEAR_SCALE: 'Seleccione una opción',
    MATRIX: 'Seleccione una opción en cada pregunta',
    SELECT: 'Se requiere una selección',
    CHECKBOX: 'Seleccione una opción',
    SHORT: 'Por favor complete',
    LONG: 'Por favor complete'
  };
  